import type { ReportSchedule } from '@components/SitemapReport/schedule'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { daysLabel, MONTH_DAYS, WEEKDAYS } from '../../utils'
import { SelectTrigger } from '../SelectTrigger'
import { DayCheck } from './DayCheck'
import css from './styles.module.scss'

interface Props {
  onToggle: (day: number) => void
  schedule: ReportSchedule
  value: number[]
}

interface OptionsProps {
  schedule: ReportSchedule
  value: number[]
}

const DayOptions: React.FC<OptionsProps> = ({ schedule, value }) => {
  const weekly = schedule === 'weekly'
  const days = weekly
    ? WEEKDAYS.map((day) => ({ day: day.value, title: day.long }))
    : MONTH_DAYS.map((day) => ({ day, title: String(day) }))

  return (
    <div className={weekly ? css.days : css.dates}>
      {days.map(({ day, title }) => (
        <DropdownMenu.Button
          id={String(day)}
          key={day}
          left={() => <DayCheck checked={value.includes(day)} />}
          preventClose
          title={title}
        />
      ))}
    </div>
  )
}

// The menu stays open while days are picked: choosing three of them is one
// decision, not three trips back to the same list.
export const DaysSelect: React.FC<Props> = ({ onToggle, schedule, value }) => (
  <DropdownMenu.Root
    align="end"
    content={DayOptions}
    onClick={(keys) => onToggle(Number(keys[0]))}
    schedule={schedule}
    value={value}
  >
    <SelectTrigger label={daysLabel(schedule, value)} />
  </DropdownMenu.Root>
)
